<div *ngIf="!passwordResetRequested; else requestSent">
  <form [formGroup]="resetForm" (ngSubmit)="onSubmitForm()" class="[ stack ]" data-cy="request-password-form">
    <dcr-text-field
      type="email"
      formControlName="email"
      label="E-mailadres"
      data-cy="input-request-password-form-email"
    ></dcr-text-field>

    <div class="[ stack stack-space-3xs ]">
      <dcr-inline-button
        class="[ flex self-end ]"
        label="Ik weet het weer!"
        (click)="onCancel()"
        data-cy="btn-request-password-form-cancel"
      ></dcr-inline-button>
    </div>
    <div class="[ flex justify-between ]">
      <dcr-filled-button
        label="Stuur een reset e-mail"
        type="submit"
        [disabled]="!resetForm.valid"
        data-cy="btn-request-password-form-reset"
      >
      </dcr-filled-button>
      <dcr-inline-button
        routerLink="/registratie"
        label="Registreer als nieuwe leerling"
        *ngIf="showRegister"
        data-cy="btn-request-password-form-register"
      ></dcr-inline-button>
    </div>
  </form>
</div>

<ng-template #requestSent>
  <div class="[ body-large text-center ] [ stack stack-space-s ]">
    <p data-cy="request-sent-message">
      We hebben een e-mail gestuurd naar <strong>{{ resetForm.value.email }}</strong> met instructies om je wachtwoord
      te resetten.
    </p>
    <dcr-filled-button label="Terug naar login" class="[ flex self-center ]" (click)="onCancel()"></dcr-filled-button>
  </div>
</ng-template>
